/// <reference types="./msg.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $auth0_user from "../../auth0_client/auth0/client/user.mjs";
import * as $comment from "../../common/data/comment.mjs";
import * as $connector from "../../common/data/connector.mjs";
import * as $connector_settings from "../../common/data/connector_settings.mjs";
import * as $copilot_message from "../../common/data/copilot_message.mjs";
import * as $data_point from "../../common/data/data_point.mjs";
import * as $data_source from "../../common/data/data_source.mjs";
import * as $docx from "../../common/data/docx.mjs";
import * as $insight from "../../common/data/insight.mjs";
import * as $maintenance from "../../common/data/maintenance.mjs";
import * as $metrics from "../../common/data/metrics.mjs";
import * as $notification from "../../common/data/notification.mjs";
import * as $page from "../../common/data/page.mjs";
import * as $project from "../../common/data/project.mjs";
import * as $proposal from "../../common/data/proposal.mjs";
import * as $proposal_element from "../../common/data/proposal_element.mjs";
import * as $question from "../../common/data/proposal_element/question.mjs";
import * as $qm from "../../common/data/qualification_matrix.mjs";
import * as $sp from "../../common/data/spreadsheet.mjs";
import * as $status from "../../common/data/status.mjs";
import * as $style_guideline from "../../common/data/style_guideline.mjs";
import * as $tag from "../../common/data/tag.mjs";
import * as $translate from "../../common/data/translate.mjs";
import * as $language from "../../common/data/translate/language.mjs";
import * as $user from "../../common/data/user.mjs";
import * as $position from "../../ds/ds/internals/position.mjs";
import * as $file from "../../ds/web/browser/file.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $toast from "../../grille_pain/grille_pain/lustre/toast.mjs";
import * as $level from "../../grille_pain/grille_pain/toast/level.mjs";
import * as $output from "../../interfaces/schemas/outline/output.mjs";
import * as $effect from "../../lustre/lustre/effect.mjs";
import * as $route from "../data/route.mjs";
import * as $blocks_events from "../elements/editors/blocks/tiptap/events.mjs";
import * as $docs_events from "../elements/editors/docs/tiptap/events.mjs";
import * as $error from "../frontend/error.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Add extends $CustomType {}

export class Remove extends $CustomType {}

export class NotSelected extends $CustomType {}

export class Selected extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class NewProposal extends $CustomType {}

export class NewProject extends $CustomType {}

export class ApiReturnedAnalytics extends $CustomType {
  constructor(analytics) {
    super();
    this.analytics = analytics;
  }
}

export class ApiSentOutline extends $CustomType {
  constructor(outline) {
    super();
    this.outline = outline;
  }
}

export class ApiSentOutlineGeneration extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

export class ApiReturnedMaintenance extends $CustomType {
  constructor(org, frozen) {
    super();
    this.org = org;
    this.frozen = frozen;
  }
}

export class ApiErroredMaintenance extends $CustomType {
  constructor(error) {
    super();
    this.error = error;
  }
}

export class ApplicationStoredAccessToken extends $CustomType {}

export class ApplicationChangedRoute extends $CustomType {
  constructor(route) {
    super();
    this.route = route;
  }
}

export class ApplicationCompletedRequest extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationQueriedProposalElements extends $CustomType {
  constructor(timeout, id) {
    super();
    this.timeout = timeout;
    this.id = id;
  }
}

export class ApplicationRequestedFetchUserData extends $CustomType {}

export class ApplicationChangedAuthState extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationRequestedToHideToast extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class ApplicationRequestedToDisplayToast extends $CustomType {
  constructor(level, message) {
    super();
    this.level = level;
    this.message = message;
  }
}

export class ApplicationRequestedToDisplayCustomToast extends $CustomType {
  constructor(options, content) {
    super();
    this.options = options;
    this.content = content;
  }
}

export class UserClosedModal extends $CustomType {}

export class UserClickedBackArrow extends $CustomType {}

export class UserClosedPopup extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserReplacedPage extends $CustomType {
  constructor(route) {
    super();
    this.route = route;
  }
}

export class UserToggledCollapsedNavbar extends $CustomType {}

export class UserClickedToOpenLink extends $CustomType {
  constructor(link) {
    super();
    this.link = link;
  }
}

export class UserDisconnected extends $CustomType {}

export class Auth0 extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Connectors extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ContentLibrary extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Docx extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Notifications extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Comment extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ProposalBuilder extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Organization extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Project extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Proposal extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Xlsx extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Narrative extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Copilot extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ModalReturnedUnsubscriber extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class MenuReturnedUnsubscriber extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ProposalReturnedUnsubscriber extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserClickedDisclosureGroup extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UnsubscriberDisclosureGroupReturned extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class BrowserResized extends $CustomType {
  constructor(dimensions) {
    super();
    this.dimensions = dimensions;
  }
}

export class ApiReturnedCopilotMessage extends $CustomType {
  constructor(message, data_sources, data_points) {
    super();
    this.message = message;
    this.data_sources = data_sources;
    this.data_points = data_points;
  }
}

export class ApiReturnedCopilotThreads extends $CustomType {
  constructor(messages, data_sources, data_points) {
    super();
    this.messages = messages;
    this.data_sources = data_sources;
    this.data_points = data_points;
  }
}

export class UserAddedCopilotToQuestionBank extends $CustomType {
  constructor(question, answer) {
    super();
    this.question = question;
    this.answer = answer;
  }
}

export class UserEdittedCopilotInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserSubmittedCopilotInput extends $CustomType {}

export class UserSelectedCopilotTag extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserDeletedCopilotTag extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserUpdatedDocument extends $CustomType {
  constructor(project, proposal, event) {
    super();
    this.project = project;
    this.proposal = proposal;
    this.event = event;
  }
}

export class ApiReturnedComments extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiCreatedComments extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiUpdatedComments extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiDeletedComments extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserArchivedComment extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserResolvedComment extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserToggledReact extends $CustomType {
  constructor(comment, react) {
    super();
    this.comment = comment;
    this.react = react;
  }
}

export class UserToggledCommentMore extends $CustomType {
  constructor(comment_id) {
    super();
    this.comment_id = comment_id;
  }
}

export class UserToggledCommentEdition extends $CustomType {
  constructor(comment) {
    super();
    this.comment = comment;
  }
}

export class UserEditedCommentEditionValue extends $CustomType {
  constructor(comment_id, value) {
    super();
    this.comment_id = comment_id;
    this.value = value;
  }
}

export class UserSubmittedCommentEdition extends $CustomType {
  constructor(comment) {
    super();
    this.comment = comment;
  }
}

export class UserCancelCommentEdition extends $CustomType {
  constructor(comment_id) {
    super();
    this.comment_id = comment_id;
  }
}

export class UserEditedComment extends $CustomType {
  constructor(comment, target_id) {
    super();
    this.comment = comment;
    this.target_id = target_id;
  }
}

export class UserSubmittedComment extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserCanceledComment extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserAddMentionToDraftComment extends $CustomType {
  constructor(comment_id, user_tagged) {
    super();
    this.comment_id = comment_id;
    this.user_tagged = user_tagged;
  }
}

export class UserRemoveMentionFromDraftComment extends $CustomType {
  constructor(comment_id, user_tagged) {
    super();
    this.comment_id = comment_id;
    this.user_tagged = user_tagged;
  }
}

export class UserAddMentionToComment extends $CustomType {
  constructor(comment, user_tagged) {
    super();
    this.comment = comment;
    this.user_tagged = user_tagged;
  }
}

export class UserRemoveMentionFromComment extends $CustomType {
  constructor(comment, user_tagged) {
    super();
    this.comment = comment;
    this.user_tagged = user_tagged;
  }
}

export class UserToggleEmojiCommentPicker extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserClickedNotification extends $CustomType {
  constructor(notification) {
    super();
    this.notification = notification;
  }
}

export class UserMarkedAllNotificationsAsRead extends $CustomType {}

export class UserMarkedNotificationAsRead extends $CustomType {
  constructor(notification_id) {
    super();
    this.notification_id = notification_id;
  }
}

export class UserToggledNotificationFeed extends $CustomType {}

export class ApiReturnedNotification extends $CustomType {
  constructor(notification) {
    super();
    this.notification = notification;
  }
}

export class ApiReturnedNotifications extends $CustomType {
  constructor(notifications) {
    super();
    this.notifications = notifications;
  }
}

export class ApiSentUserFunctionUpdated extends $CustomType {
  constructor($0, $1, $2) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
  }
}

export class ApiReturnedUsers extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiReturnedTags extends $CustomType {
  constructor(tags) {
    super();
    this.tags = tags;
  }
}

export class ApiReturnedStyleGuideline extends $CustomType {
  constructor(style_guideline) {
    super();
    this.style_guideline = style_guideline;
  }
}

export class ApiReturnedStyleGuidelines extends $CustomType {
  constructor(style_guidelines) {
    super();
    this.style_guidelines = style_guidelines;
  }
}

export class ApiReturnedQualificationMatrix extends $CustomType {
  constructor(qm) {
    super();
    this.qm = qm;
  }
}

export class UserClickedOnAddStyleGuideline extends $CustomType {}

export class UserClickedOnStyleGuideline extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserDeletedStyleGuideline extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserSelectedFunction extends $CustomType {
  constructor(user_id, function$) {
    super();
    this.user_id = user_id;
    this.function = function$;
  }
}

export class UserSubmittedNewStyleGuideline extends $CustomType {}

export class UserUpdatedNewStyleGuidelineName extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class UserUpdatedNewStyleGuidelineContent extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

export class ApiDeletedProject extends $CustomType {
  constructor(project_id) {
    super();
    this.project_id = project_id;
  }
}

export class ApiReturnedProjects extends $CustomType {
  constructor(projects, updating) {
    super();
    this.projects = projects;
    this.updating = updating;
  }
}

export class BrowserExtractedNewProjectAttachments extends $CustomType {
  constructor(id, attachments) {
    super();
    this.id = id;
    this.attachments = attachments;
  }
}

export class UserSavedProjectTitle extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserToggledCollapsedProject extends $CustomType {
  constructor(project) {
    super();
    this.project = project;
  }
}

export class UserToggledProjectCollaborator extends $CustomType {
  constructor(project_id, user_id) {
    super();
    this.project_id = project_id;
    this.user_id = user_id;
  }
}

export class UserToggledProjectTitle extends $CustomType {}

export class UserUpdatedProjectTitle extends $CustomType {
  constructor(id, title) {
    super();
    this.id = id;
    this.title = title;
  }
}

export class UserAddedAttachments extends $CustomType {
  constructor(id, attachments) {
    super();
    this.id = id;
    this.attachments = attachments;
  }
}

export class UserExportedProject extends $CustomType {
  constructor(project_id) {
    super();
    this.project_id = project_id;
  }
}

export class BrowserDisplayedToast extends $CustomType {
  constructor(project_id, toast_id) {
    super();
    this.project_id = project_id;
    this.toast_id = toast_id;
  }
}

export class UserWillDeleteProject extends $CustomType {
  constructor(project_id) {
    super();
    this.project_id = project_id;
  }
}

export class UserDeletedProject extends $CustomType {
  constructor(project_id) {
    super();
    this.project_id = project_id;
  }
}

export class UserEditedDeleteConfirmInput extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}

export class UserDisplayedModalChangeProjectStatus extends $CustomType {
  constructor(project_id, status) {
    super();
    this.project_id = project_id;
    this.status = status;
  }
}

export class UserChangedProjectStatus extends $CustomType {
  constructor(id, status) {
    super();
    this.id = id;
    this.status = status;
  }
}

export class UserFocusReplyComment extends $CustomType {
  constructor(target_id) {
    super();
    this.target_id = target_id;
  }
}

export class ApiDeletedProposal extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}

export class ApiSentElementDeleted extends $CustomType {
  constructor(proposal_id, element_id) {
    super();
    this.proposal_id = proposal_id;
    this.element_id = element_id;
  }
}

export class ApiRejectedProposal extends $CustomType {
  constructor(proposal) {
    super();
    this.proposal = proposal;
  }
}

export class ApiRejectedProposalElement extends $CustomType {
  constructor(element) {
    super();
    this.element = element;
  }
}

export class ApiReturnedProposalElement extends $CustomType {
  constructor(element) {
    super();
    this.element = element;
  }
}

export class ApiReturnedProposals extends $CustomType {
  constructor($0, updating) {
    super();
    this[0] = $0;
    this.updating = updating;
  }
}

export class ApiReturnedProposalsElements extends $CustomType {
  constructor(elements, data_sources, data_points) {
    super();
    this.elements = elements;
    this.data_sources = data_sources;
    this.data_points = data_points;
  }
}

export class ApiSentElementUpdated extends $CustomType {
  constructor($0, $1, $2) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
  }
}

export class ApiReturnedTranslations extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiTimeoutedProposalsQuestions extends $CustomType {}

export class UserSelectedProposalLanguage extends $CustomType {
  constructor(language) {
    super();
    this.language = language;
  }
}

export class UserToggledFilterProposal extends $CustomType {}

export class UserUpdatedProposalFiltersOwner extends $CustomType {
  constructor(owner) {
    super();
    this.owner = owner;
  }
}

export class UserUpdatedProposalFiltersStatus extends $CustomType {
  constructor(status) {
    super();
    this.status = status;
  }
}

export class UserAssignedStatusInProposal extends $CustomType {
  constructor(validated, proposal_id) {
    super();
    this.validated = validated;
    this.proposal_id = proposal_id;
  }
}

export class UserChoseAttachment extends $CustomType {
  constructor(proposal, question, files) {
    super();
    this.proposal = proposal;
    this.question = question;
    this.files = files;
  }
}

export class UserClickedAddToQuestionBank extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class UserClickedAiImprove extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class UserClickedAiPreset extends $CustomType {
  constructor(thread_id, preset) {
    super();
    this.thread_id = thread_id;
    this.preset = preset;
  }
}

export class UserClickedAiAcceptAnswer extends $CustomType {
  constructor(question, thread_id) {
    super();
    this.question = question;
    this.thread_id = thread_id;
  }
}

export class UserClickedAiEndConversation extends $CustomType {
  constructor(question_id) {
    super();
    this.question_id = question_id;
  }
}

export class UserSubmittedAiConversation extends $CustomType {
  constructor(thread_id) {
    super();
    this.thread_id = thread_id;
  }
}

export class UserEditedAiConversation extends $CustomType {
  constructor(thread_id, content) {
    super();
    this.thread_id = thread_id;
    this.content = content;
  }
}

export class UserClickedGlobalProposalCheckbox extends $CustomType {
  constructor(all_selected, questions) {
    super();
    this.all_selected = all_selected;
    this.questions = questions;
  }
}

export class UserClickedOutsideInProposal extends $CustomType {}

export class UserClickedProposal extends $CustomType {
  constructor(proposal, sheet) {
    super();
    this.proposal = proposal;
    this.sheet = sheet;
  }
}

export class UserClosedProposalMenuBar extends $CustomType {}

export class UserDeletedAttachment extends $CustomType {
  constructor(proposal, question, attachment) {
    super();
    this.proposal = proposal;
    this.question = question;
    this.attachment = attachment;
  }
}

export class UserDeletedQuestionInProposal extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class UserDeletedProposal extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserDisplayedDeleteProposalModal extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserDisplayedDeleteQuestionInProposalModal extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class UserClickedAddComment extends $CustomType {
  constructor(proposal_id, question_id, offset, heights) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
    this.offset = offset;
    this.heights = heights;
  }
}

export class UserEdittedCustomRewording extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserSelectedElementOwner extends $CustomType {
  constructor(element_id, proposal_id, user_id) {
    super();
    this.element_id = element_id;
    this.proposal_id = proposal_id;
    this.user_id = user_id;
  }
}

export class UserSelectedProposalPage extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}

export class UserSelectedQuestion extends $CustomType {
  constructor(id, checked) {
    super();
    this.id = id;
    this.checked = checked;
  }
}

export class UserSubmittedCustomRewording extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class UserToggledAssignUserPopupInProposal extends $CustomType {
  constructor(user_id, proposal_id) {
    super();
    this.user_id = user_id;
    this.proposal_id = proposal_id;
  }
}

export class UserToggledChangeOwnerPopupInProposal extends $CustomType {}

export class UserToggledChangeStatusPopupInProposal extends $CustomType {}

export class UserToggledQuestionMenu extends $CustomType {
  constructor(question_id) {
    super();
    this.question_id = question_id;
  }
}

export class UserToggledProposalMenu extends $CustomType {
  constructor(proposal_id, rect) {
    super();
    this.proposal_id = proposal_id;
    this.rect = rect;
  }
}

export class UserUpdatedProposalQuestion extends $CustomType {
  constructor(question, tr, language) {
    super();
    this.question = question;
    this.tr = tr;
    this.language = language;
  }
}

export class UserUpdatedProposalQuestionChoice extends $CustomType {
  constructor(question, choice) {
    super();
    this.question = question;
    this.choice = choice;
  }
}

export class UserUpdatedProposalQuestionYesNo extends $CustomType {
  constructor(question, yes_no) {
    super();
    this.question = question;
    this.yes_no = yes_no;
  }
}

export class UserChangedQuestionValidated extends $CustomType {
  constructor(question, validated) {
    super();
    this.question = question;
    this.validated = validated;
  }
}

export class UserToggleComment extends $CustomType {
  constructor(target_id, offset, heights) {
    super();
    this.target_id = target_id;
    this.offset = offset;
    this.heights = heights;
  }
}

export class RecomputeQuestionsContainerHeights extends $CustomType {
  constructor(heights) {
    super();
    this.heights = heights;
  }
}

export class UserSelectedCreation extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class GenerateXlsx extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}

export class DownloadXlsx extends $CustomType {
  constructor(proposal_id, toast_id) {
    super();
    this.proposal_id = proposal_id;
    this.toast_id = toast_id;
  }
}

export class GenerateDocx extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}

export class DownloadDocx extends $CustomType {
  constructor(proposal_id, toast_id) {
    super();
    this.proposal_id = proposal_id;
    this.toast_id = toast_id;
  }
}

export class ApiReturnedConnectorData extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

export class ApiReturnedConnectorSettings extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserAddedConfluencePage extends $CustomType {}

export class UserAddedGoogleFolderUrl extends $CustomType {}

export class UserAddedWebsitePage extends $CustomType {}

export class UserAskedConnectingTo extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserFetchedConnectorData extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserToggledConfluencePanel extends $CustomType {}

export class UserToggledGoogleDrivePanel extends $CustomType {}

export class UserToggledSalesforcePanel extends $CustomType {}

export class UserToggledWebsitePanel extends $CustomType {}

export class UserUpdatedConfluenceApiKey extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedConfluenceDomain extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserRemovedConfluencePage extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedSalesforceDomain extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedSalesforceClientId extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedSalesforceClientSecret extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserRemovedSitemapPage extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserRequetedSitemapSync extends $CustomType {}

export class UserRemovedConnectedWebsitePage extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserRemovedGoogleFolderUrl extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedConfluencePageInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedWebsitePageInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedConfluenceUser extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserToggledNotionPanel extends $CustomType {}

export class UserUpdatedNotionApiKey extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedNotionPageId extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUpdatedGoogleFolderUrlInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserUploadedSiteMap extends $CustomType {
  constructor(sitemap) {
    super();
    this.sitemap = sitemap;
  }
}

export class SitemapParsed extends $CustomType {
  constructor(urls) {
    super();
    this.urls = urls;
  }
}

export class ApiUpsertedInsight extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

export class ApiRejectedUploadingQuestion extends $CustomType {
  constructor(ingestion, error) {
    super();
    this.ingestion = ingestion;
    this.error = error;
  }
}

export class ApiRejectUpdatingContentLibrary extends $CustomType {
  constructor(error) {
    super();
    this.error = error;
  }
}

export class ApiResolvedInsight extends $CustomType {
  constructor(insight) {
    super();
    this.insight = insight;
  }
}

export class ApiReturnedInsights extends $CustomType {
  constructor(insights, data_points) {
    super();
    this.insights = insights;
    this.data_points = data_points;
  }
}

export class ApiReturnedSource extends $CustomType {
  constructor(source) {
    super();
    this.source = source;
  }
}

export class ApiReturnedQnaSources extends $CustomType {
  constructor(sources) {
    super();
    this.sources = sources;
  }
}

export class ApiReturnedNonQnaSources extends $CustomType {
  constructor(sources) {
    super();
    this.sources = sources;
  }
}

export class ApiReturnedSourceStatusStats extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiReturnedQuestionStatusStats extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApiUpsertedDataSources extends $CustomType {
  constructor(sources) {
    super();
    this.sources = sources;
  }
}

export class ApiReturnedUploadingQuestion extends $CustomType {
  constructor(ingestion) {
    super();
    this.ingestion = ingestion;
  }
}

export class ApiSuccessfullyProcessedFiles extends $CustomType {
  constructor(total) {
    super();
    this.total = total;
  }
}

export class ContentLibraryHandledSpreadsheetSelector extends $CustomType {
  constructor(msg) {
    super();
    this.msg = msg;
  }
}

export class ContentLibraryReturnedUnsubscriber extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserAssignedExpirationDate extends $CustomType {
  constructor(expiration_date) {
    super();
    this.expiration_date = expiration_date;
  }
}

export class UserAssignedStatusInContentLibrary extends $CustomType {
  constructor(status) {
    super();
    this.status = status;
  }
}

export class UserAssignedTag extends $CustomType {
  constructor(tag, add_remove) {
    super();
    this.tag = tag;
    this.add_remove = add_remove;
  }
}

export class UserClickedGlobalCheckbox extends $CustomType {
  constructor(all_selected, sources) {
    super();
    this.all_selected = all_selected;
    this.sources = sources;
  }
}

export class UserClickedOutsideInContentLibrary extends $CustomType {}

export class UserClosedContentLibraryMenuBar extends $CustomType {}

export class UserToggledFilterLibrary extends $CustomType {}

export class UserSelectedFilterTagLibrary extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserSelectedFilterCollaboratorLibrary extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserCreatedQuestion extends $CustomType {}

export class UserDeletedDataSource extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserDisplayedDeleteDataSourceModal extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class UserEdittedQuestion extends $CustomType {
  constructor(question_id) {
    super();
    this.question_id = question_id;
  }
}

export class UserFixedConflict extends $CustomType {
  constructor(insight, chosen_id, deleted_id) {
    super();
    this.insight = insight;
    this.chosen_id = chosen_id;
    this.deleted_id = deleted_id;
  }
}

export class UserFixedDuplicate extends $CustomType {
  constructor(insight, chosen_id, deleted_id) {
    super();
    this.insight = insight;
    this.chosen_id = chosen_id;
    this.deleted_id = deleted_id;
  }
}

export class UserFixedIrrelevant extends $CustomType {
  constructor(insight) {
    super();
    this.insight = insight;
  }
}

export class UserSelectedInsightCard extends $CustomType {
  constructor(id, insight_id) {
    super();
    this.id = id;
    this.insight_id = insight_id;
  }
}

export class UserSelectedContentLibraryPage extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}

export class UserSelectedInsightFilter extends $CustomType {
  constructor(filter) {
    super();
    this.filter = filter;
  }
}

export class UserSelectedFilter extends $CustomType {
  constructor(filter) {
    super();
    this.filter = filter;
  }
}

export class UserSelectedSource extends $CustomType {
  constructor(id, checked) {
    super();
    this.id = id;
    this.checked = checked;
  }
}

export class UserSkippedInsight extends $CustomType {
  constructor(insight) {
    super();
    this.insight = insight;
  }
}

export class UserSubmittedQuestionBankEdit extends $CustomType {}

export class UserToggledAssignUserPopupInContentLibrary extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}

export class UserToggledChangeExpirationDatePopup extends $CustomType {}

export class UserToggledChangeOwnerPopupInContentLibrary extends $CustomType {}

export class UserToggledChangeStatusPopupInContentLibrary extends $CustomType {}

export class UserToggledChangeTags extends $CustomType {}

export class UserUpdatedExpirationDateInput extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}

export class UserUpdatedQuestionBankEditAnswer extends $CustomType {
  constructor(answer) {
    super();
    this.answer = answer;
  }
}

export class UserUpdatedQuestionBankEditQuestion extends $CustomType {
  constructor(question) {
    super();
    this.question = question;
  }
}

export class UserUpdatedSearch extends $CustomType {
  constructor(search) {
    super();
    this.search = search;
  }
}

export class UserUploadedSourceFiles extends $CustomType {
  constructor(sources) {
    super();
    this.sources = sources;
  }
}

export class ApiReturnedSavedProposal extends $CustomType {
  constructor(saved_proposal) {
    super();
    this.saved_proposal = saved_proposal;
  }
}

export class ProposalBuilderHandledSpreadsheetSelector extends $CustomType {
  constructor(msg) {
    super();
    this.msg = msg;
  }
}

export class ProposalBuilderHandledDocumentSelector extends $CustomType {
  constructor(msg) {
    super();
    this.msg = msg;
  }
}

export class ProposalBuilderHandledPdfSelector extends $CustomType {
  constructor(msg) {
    super();
    this.msg = msg;
  }
}

export class UserAddedProposalLanguage extends $CustomType {
  constructor(language) {
    super();
    this.language = language;
  }
}

export class UserAddedProposalTag extends $CustomType {
  constructor(tag) {
    super();
    this.tag = tag;
  }
}

export class UserAddedProposalStyleGuideline extends $CustomType {
  constructor(style_guideline) {
    super();
    this.style_guideline = style_guideline;
  }
}

export class UserConfirmedModalProposalQualificationMatrix extends $CustomType {}

export class UserConfirmedProposalQualificationMatrix extends $CustomType {}

export class UserEditedProjectUser extends $CustomType {
  constructor(action) {
    super();
    this.action = action;
  }
}

export class UserRemovedProposalLanguage extends $CustomType {
  constructor(language) {
    super();
    this.language = language;
  }
}

export class UserRemovedProposalStyleGuideline extends $CustomType {}

export class UserRemovedProposalTag extends $CustomType {
  constructor(tag) {
    super();
    this.tag = tag;
  }
}

export class UserSelectedProposalQualificationMatrix extends $CustomType {
  constructor(id, answer) {
    super();
    this.id = id;
    this.answer = answer;
  }
}

export class UserSkippedProposalQualificationMatrix extends $CustomType {}

export class UserSubmittedProjectDetails extends $CustomType {}

export class UserSubmittedProposalDetails extends $CustomType {}

export class UserUpdatedContext extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}

export class UserUpdatedProjectClient extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class UserUpdatedProjectSalesforceId extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class UserUpdatedProjectDeadline extends $CustomType {
  constructor(deadline) {
    super();
    this.deadline = deadline;
  }
}

export class UserUpdatedProjectName extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class UserUsedProposalQualificationMatrix extends $CustomType {}

export class UserAddedProjectAttachments extends $CustomType {
  constructor(attachments) {
    super();
    this.attachments = attachments;
  }
}

export class UserWentBack extends $CustomType {
  constructor(router) {
    super();
    this.router = router;
  }
}

export class UserRemovedProjectAttachment extends $CustomType {
  constructor(index) {
    super();
    this.index = index;
  }
}

export class BrowserExtractedProjectAttachments extends $CustomType {
  constructor(attachments) {
    super();
    this.attachments = attachments;
  }
}

export class UserSelectedProjectId extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserPrefilledProposal extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}

export class UserUpdatedProposalName extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserWillRetriggerProposal extends $CustomType {
  constructor(override_validated) {
    super();
    this.override_validated = override_validated;
  }
}

export class UserToggledOverrideValidated extends $CustomType {
  constructor(proposal_id, value) {
    super();
    this.proposal_id = proposal_id;
    this.value = value;
  }
}

export class UserAddedCollaborator extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}

export class UserRemovedCollaborator extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}

export class UserAddedOwner extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}

export class UserRemovedOwner extends $CustomType {
  constructor(user_id) {
    super();
    this.user_id = user_id;
  }
}

export class ApiAutoDetectedXlsxColumns extends $CustomType {
  constructor(sheet, column_types, section_column) {
    super();
    this.sheet = sheet;
    this.column_types = column_types;
    this.section_column = section_column;
  }
}

export class ApiAutoDetectedXlsxRows extends $CustomType {
  constructor(sheet, rows_type) {
    super();
    this.sheet = sheet;
    this.rows_type = rows_type;
  }
}

export class ApiFailedToDetectXlsxColumns extends $CustomType {
  constructor(sheet) {
    super();
    this.sheet = sheet;
  }
}

export class ApiFailedToDetectXlsxRows extends $CustomType {
  constructor(sheet) {
    super();
    this.sheet = sheet;
  }
}

export class ApiFetchedXlsx extends $CustomType {
  constructor(decoded_sheet) {
    super();
    this.decoded_sheet = decoded_sheet;
  }
}

export class BrowserDecodedXlsxFile extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class UserAssignedRowTypeInSelector extends $CustomType {
  constructor(sheet, row_type) {
    super();
    this.sheet = sheet;
    this.row_type = row_type;
  }
}

export class UserCancelledSpreadsheetSelection extends $CustomType {}

export class UserChangedColumnType extends $CustomType {
  constructor(sheet, index, type_) {
    super();
    this.sheet = sheet;
    this.index = index;
    this.type_ = type_;
  }
}

export class UserChangedRowType extends $CustomType {
  constructor(sheet, index, validity) {
    super();
    this.sheet = sheet;
    this.index = index;
    this.validity = validity;
  }
}

export class UserClickedSelectAll extends $CustomType {
  constructor(nb_rows, sheet) {
    super();
    this.nb_rows = nb_rows;
    this.sheet = sheet;
  }
}

export class UserClosedSelectorMenu extends $CustomType {}

export class UserSelectedRow extends $CustomType {
  constructor(sheet, index, checked) {
    super();
    this.sheet = sheet;
    this.index = index;
    this.checked = checked;
  }
}

export class UserSelectedXlsx extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class UserSkippedSelectedSheet extends $CustomType {
  constructor(current_sheet, next_sheet) {
    super();
    this.current_sheet = current_sheet;
    this.next_sheet = next_sheet;
  }
}

export class UserSubmittedXlsx extends $CustomType {}

export class UserToggledChangeRowTypePoppupInSpreadsheetSelector extends $CustomType {}

export class UserUpdatedSelectedSheet extends $CustomType {
  constructor(sheet) {
    super();
    this.sheet = sheet;
  }
}

export class ApiFetchedDocx extends $CustomType {
  constructor(decoded_docx) {
    super();
    this.decoded_docx = decoded_docx;
  }
}

export class BrowserDecodedDocxFile extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class UserIssuedTransaction extends $CustomType {
  constructor(event) {
    super();
    this.event = event;
  }
}

export class UserSelectedDocx extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class UserSubmittedDocument extends $CustomType {}

export class BrowserDecodedPdfFile extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class ApiFetchedOutline extends $CustomType {
  constructor(outline) {
    super();
    this.outline = outline;
  }
}

export class UserSelectedPdf extends $CustomType {
  constructor(file) {
    super();
    this.file = file;
  }
}

export class UserSubmittedPdf extends $CustomType {}

function project_decoder() {
  return $decode.field(
    "project",
    $project.decoder(),
    (project) => {
      let _pipe = $decode.success(
        new ApiReturnedProjects(toList([project]), false),
      );
      return $decode.map(_pipe, (var0) => { return new Project(var0); });
    },
  );
}

function proposal_updated_decoder() {
  return $decode.field(
    "proposal",
    $proposal.decoder(),
    (proposal) => {
      let _pipe = $decode.success(
        new ApiReturnedProposals(toList([proposal]), false),
      );
      return $decode.map(_pipe, (var0) => { return new Proposal(var0); });
    },
  );
}

function element_updated_decoder() {
  return $decode.field(
    "element",
    $proposal_element.decoder(),
    (element) => {
      let data_sources = $decode.list($data_source.decoder());
      return $decode.field(
        "data_sources",
        data_sources,
        (data_sources) => {
          let data_points = $decode.list($data_point.decoder());
          return $decode.field(
            "data_points",
            data_points,
            (data_points) => {
              let _pipe = $decode.success(
                new ApiSentElementUpdated(element, data_sources, data_points),
              );
              return $decode.map(
                _pipe,
                (var0) => { return new Proposal(var0); },
              );
            },
          );
        },
      );
    },
  );
}

function connector_registered_decoder() {
  return $decode.field(
    "connector",
    $connector.decoder(),
    (connector) => {
      return $decode.field(
        "status",
        $decode.bool,
        (status) => {
          let _pipe = $decode.success(
            new ApiReturnedConnectorData(connector, status),
          );
          return $decode.map(_pipe, (var0) => { return new Connectors(var0); });
        },
      );
    },
  );
}

function connector_settings_updated_decoder() {
  let settings = $connector_settings.decoder();
  return $decode.field(
    "connector_settings",
    settings,
    (settings) => {
      let _pipe = $decode.success(
        new ApiReturnedConnectorSettings(toList([settings])),
      );
      return $decode.map(_pipe, (var0) => { return new Connectors(var0); });
    },
  );
}

function notification_updated_decoder() {
  return $decode.field(
    "notification",
    $notification.decoder(),
    (notification) => {
      let _pipe = $decode.success(new ApiReturnedNotification(notification));
      return $decode.map(_pipe, (var0) => { return new Notifications(var0); });
    },
  );
}

function data_sources_updated_decoder() {
  let data_sources = $decode.list($data_source.decoder());
  return $decode.field(
    "data_sources",
    data_sources,
    (data_sources) => {
      let _pipe = $decode.success(new ApiUpsertedDataSources(data_sources));
      return $decode.map(_pipe, (var0) => { return new ContentLibrary(var0); });
    },
  );
}

function user_data_updated_decoder() {
  return $decode.field(
    "user_id",
    $decode.string,
    (user_id) => {
      return $decode.field(
        "org_id",
        $decode.string,
        (org_id) => {
          return $decode.field(
            "function",
            $user.function_decoder(),
            (function$) => {
              let _pipe = $decode.success(
                new ApiSentUserFunctionUpdated(user_id, org_id, function$),
              );
              return $decode.map(
                _pipe,
                (var0) => { return new Organization(var0); },
              );
            },
          );
        },
      );
    },
  );
}

function translation_decoder() {
  let translation = $translate.translation_decoder();
  return $decode.field(
    "translation",
    translation,
    (translation) => {
      let _pipe = $decode.success(
        new ApiReturnedTranslations(toList([translation])),
      );
      return $decode.map(_pipe, (var0) => { return new Proposal(var0); });
    },
  );
}

function deleted_element_decoder() {
  return $decode.field(
    "element_id",
    $decode.string,
    (element_id) => {
      return $decode.field(
        "proposal_id",
        $decode.string,
        (proposal_id) => {
          let _pipe = $decode.success(
            new ApiSentElementDeleted(element_id, proposal_id),
          );
          return $decode.map(_pipe, (var0) => { return new Proposal(var0); });
        },
      );
    },
  );
}

function deleted_project_decoder() {
  return $decode.field(
    "project_id",
    $decode.string,
    (project_id) => {
      let _pipe = $decode.success(new ApiDeletedProject(project_id));
      return $decode.map(_pipe, (var0) => { return new Project(var0); });
    },
  );
}

function deleted_proposal_decoder() {
  return $decode.field(
    "proposal_id",
    $decode.string,
    (proposal_id) => {
      let _pipe = $decode.success(new ApiDeletedProposal(proposal_id));
      return $decode.map(_pipe, (var0) => { return new Proposal(var0); });
    },
  );
}

function insight_decoder() {
  return $decode.field(
    "insight",
    $insight.decoder(),
    (insight) => {
      return $decode.field(
        "conflict_data_points",
        $decode.list($data_point.decoder()),
        (conflict_data_points) => {
          let _pipe = $decode.success(
            new ApiUpsertedInsight(insight, conflict_data_points),
          );
          return $decode.map(
            _pipe,
            (var0) => { return new ContentLibrary(var0); },
          );
        },
      );
    },
  );
}

function outline_decoder() {
  let _pipe = $decode.at(toList(["outline"]), $output.outline_output_decoder());
  return $decode.map(_pipe, (var0) => { return new ApiSentOutline(var0); });
}

function outline_generation_decoder() {
  return $decode.field(
    "answer",
    $decode.string,
    (answer) => {
      return $decode.field(
        "block_id",
        $decode.string,
        (block_id) => {
          return $decode.success(new ApiSentOutlineGeneration(answer, block_id));
        },
      );
    },
  );
}

function comment_message_decoder() {
  return $decode.field(
    "comment",
    $comment.decoder(),
    (comment) => {
      let _block;
      let $ = comment.is_deleted;
      if ($) {
        _block = new Comment(new ApiDeletedComments(toList([comment])));
      } else {
        _block = new Comment(new ApiUpdatedComments(toList([comment])));
      }
      let _pipe = _block;
      return $decode.success(_pipe);
    },
  );
}

function copilot_message_decoder() {
  return $decode.field(
    "message",
    $copilot_message.decoder(),
    (message) => {
      return $decode.field(
        "data_points",
        $decode.list($data_point.decoder()),
        (data_points) => {
          return $decode.field(
            "data_sources",
            $decode.list($data_source.decoder()),
            (data_sources) => {
              let _pipe = new ApiReturnedCopilotMessage(
                message,
                data_sources,
                data_points,
              );
              let _pipe$1 = new Copilot(_pipe);
              return $decode.success(_pipe$1);
            },
          );
        },
      );
    },
  );
}

export function incoming_decoder() {
  return $decode.then$(
    $decode.at(toList(["type"]), $decode.string),
    (type_) => {
      if (type_ === "project") {
        return project_decoder();
      } else if (type_ === "proposal") {
        return proposal_updated_decoder();
      } else if (type_ === "proposal_element") {
        return element_updated_decoder();
      } else if (type_ === "connector_registered") {
        return connector_registered_decoder();
      } else if (type_ === "connector_settings") {
        return connector_settings_updated_decoder();
      } else if (type_ === "notification") {
        return notification_updated_decoder();
      } else if (type_ === "data_sources") {
        return data_sources_updated_decoder();
      } else if (type_ === "user_data") {
        return user_data_updated_decoder();
      } else if (type_ === "translation") {
        return translation_decoder();
      } else if (type_ === "insight") {
        return insight_decoder();
      } else if (type_ === "deleted_proposal_element") {
        return deleted_element_decoder();
      } else if (type_ === "deleted_project") {
        return deleted_project_decoder();
      } else if (type_ === "deleted_proposal") {
        return deleted_proposal_decoder();
      } else if (type_ === "outline_output") {
        return outline_decoder();
      } else if (type_ === "outline_generation") {
        return outline_generation_decoder();
      } else if (type_ === "comment") {
        return comment_message_decoder();
      } else if (type_ === "copilot_message") {
        return copilot_message_decoder();
      } else {
        return $decode.failure(
          new ApplicationCompletedRequest(""),
          "ApiSentMessage",
        );
      }
    },
  );
}
